<div class="sn-wrap" [class.sn-wrap--cards]="cardLayout">

  <div *ngIf="!reportId" class="sn-muted">Save the report first to configure scheduled notifications.</div>

  <ng-container *ngIf="reportId">
    <div *ngIf="scheduleLoading" class="sn-loading">Loading schedule…</div>

    <div *ngIf="scheduleLoadError" class="sn-error">{{ scheduleLoadError }}</div>

    <ng-container *ngIf="!scheduleLoading && !scheduleLoadError">

      <!-- Delivery Schedule -->
      <div class="sn-step">
        <ng-container *ngTemplateOutlet="stepHead; context: { title: 'Delivery schedule', hint: 'When the email goes out' }"></ng-container>

        <div class="sn-field">
            <label class="sn-field__label">Frequency</label>
            <div class="freq-tabs" role="radiogroup" aria-label="Frequency">
              <button type="button" role="radio"
                [attr.aria-checked]="scheduleForm.frequency === 'daily'"
                class="freq-tab" [class.freq-tab--active]="scheduleForm.frequency === 'daily'"
                (click)="onFrequencyChange('daily')">Daily</button>
              <button type="button" role="radio"
                [attr.aria-checked]="scheduleForm.frequency === 'weekly'"
                class="freq-tab" [class.freq-tab--active]="scheduleForm.frequency === 'weekly'"
                (click)="onFrequencyChange('weekly')">Weekly</button>
              <button type="button" role="radio"
                [attr.aria-checked]="scheduleForm.frequency === 'monthly'"
                class="freq-tab" [class.freq-tab--active]="scheduleForm.frequency === 'monthly'"
                (click)="onFrequencyChange('monthly')">Monthly</button>
            </div>
          </div>

          <div *ngIf="scheduleForm.frequency === 'weekly'" class="sn-field">
            <label class="sn-field__label">Day(s) of week</label>
            <div class="day-grid" role="group" aria-label="Days of week">
              <button type="button" *ngFor="let d of [
                { value: 1, label: 'Mon' },
                { value: 2, label: 'Tue' },
                { value: 3, label: 'Wed' },
                { value: 4, label: 'Thu' },
                { value: 5, label: 'Fri' },
                { value: 6, label: 'Sat' },
                { value: 0, label: 'Sun' }
              ]"
                class="day-pill"
                [class.day-pill--selected]="scheduleForm.weeklyDays.includes(d.value)"
                [attr.aria-pressed]="scheduleForm.weeklyDays.includes(d.value)"
                (click)="toggleWeeklyDay(d.value)">
                {{ d.label }}
              </button>
            </div>
          </div>

          <div *ngIf="scheduleForm.frequency === 'monthly'" class="sn-field">
            <label class="sn-field__label">Day of month</label>
            <div class="month-row">
              <input class="sn-input month-input" type="number" min="1" max="31"
                [ngModel]="scheduleForm.monthlyDays[0]" (ngModelChange)="onMonthlyDayChange($event)">
              <span class="month-hint">Days 29–31 fall back to last day of shorter months</span>
            </div>
          </div>

          <div class="sn-field">
            <label class="sn-field__label">Time of delivery</label>
            <div class="time-row">
              <input class="sn-input time-input" type="time"
                [ngModel]="scheduleForm.timeEST" (ngModelChange)="onTimeEstChange($event)">
              <span class="est-badge">EST</span>
            </div>
          </div>

          <div class="preview-box">
            <div class="preview-icon" *ngIf="!themedIcon">📅</div>
            <i class="preview-icon preview-icon--fa fa fa-calendar"
              *ngIf="themedIcon" aria-hidden="true"></i>
            <div>
              <div class="preview-text"><strong>Next send:</strong> {{ getNextSendPreview() }}</div>
              <div class="preview-text preview-text--sub">Then {{ getFrequencyLabel() }}</div>
            </div>
          </div>
      </div>

      <ng-container *ngIf="supportsTableInBody">
        <hr class="sn-divider" *ngIf="!cardLayout">

        <!-- Email content -->
        <div class="sn-step">
          <ng-container *ngTemplateOutlet="stepHead; context: { title: 'Email content', hint: 'What the email holds besides the attached file' }"></ng-container>
          <div class="sn-field">
            <label class="sn-field__label body-table-option">
              <input type="checkbox" class="rcb-input"
                [ngModel]="scheduleForm.includeTableInBody" (ngModelChange)="onIncludeTableInBodyChange($event)">
              Show the table in the email body
            </label>
            <span class="sn-hint">The first 200 rows. The Excel file is still attached.</span>
          </div>
        </div>
      </ng-container>

      <hr class="sn-divider" *ngIf="!cardLayout">

      <!-- Recipients -->
      <div class="sn-step">
        <ng-container *ngTemplateOutlet="stepHead; context: { title: 'Recipients', hint: 'Who receives it' }"></ng-container>

        <!-- Collapsed: who gets it, in one line, with the way in. The roster of
             every eligible user only appears when it is being changed. -->
        <div class="sn-recip-summary" *ngIf="collapsibleRecipients && !recipientsOpen">
          <span class="sn-recip-summary__who">{{ recipientSummary }}</span>
          <span class="sn-recip-summary__count"
            *ngIf="eligibleRecipients.length">{{ selectedRecipientIds.size }} of {{ eligibleRecipients.length }}</span>
          <button type="button" class="sn-recip-summary__btn"
            [attr.aria-expanded]="false" (click)="toggleRecipientsOpen()">Change</button>
        </div>

        <ng-container *ngIf="!collapsibleRecipients || recipientsOpen">
        <p class="sn-hint">Only users with view permission for this report are shown. Selection is optional — you can save and edit recipients at any time.</p>

        <div *ngIf="eligibleRecipients.length" class="sn-field">
          <input class="sn-input" [(ngModel)]="recipientSearchFilter"
            (ngModelChange)="onRecipientSearchChange()" placeholder="Search by name or email…">
          <span class="sn-hint sn-hint--count">{{ selectedRecipientIds.size }} of {{ eligibleRecipients.length }} selected</span>
        </div>

        <div *ngIf="eligibleRecipients.length" class="recip">
          <table class="recip__table">
            <thead>
              <tr>
                <th class="recip__th recip__th--cb">
                  <input type="checkbox" class="rcb-input"
                    [checked]="allRecipientsSelected"
                    [indeterminate]="someRecipientsSelected"
                    (change)="toggleAllRecipients()">
                </th>
                <th class="recip__th">Role</th>
                <th class="recip__th">Name</th>
                <th class="recip__th">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of filteredEligibleRecipients; trackBy: trackByRecipientId"
                class="recip__row" (click)="toggleRecipient(user._id)">
                <td class="recip__td recip__td--cb">
                  <input type="checkbox" class="rcb-input"
                    [checked]="selectedRecipientIds.has(user._id)"
                    (change)="toggleRecipient(user._id)"
                    (click)="$event.stopPropagation()">
                </td>
                <td class="recip__td">
                  <span class="role-badge"
                    [class.role-admin]="getRoleBadge(user.roleNumber) === 'Admin'"
                    [class.role-viewer]="getRoleBadge(user.roleNumber) === 'Viewer'">
                    {{ getRoleBadge(user.roleNumber) }}
                  </span>
                </td>
                <td class="recip__td">{{ user.privateName }}</td>
                <td class="recip__td recip__td--email">{{ user.email }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="!eligibleRecipients.length" class="sn-muted">No eligible recipients found.</div>

        <button type="button" class="sn-recip-done" *ngIf="collapsibleRecipients"
          [attr.aria-expanded]="true" (click)="toggleRecipientsOpen()">Done</button>
        </ng-container>
      </div>

    </ng-container>
  </ng-container>

</div>

<ng-template #stepHead let-title="title" let-hint="hint">
  <div *ngIf="cardLayout; else plainHead" class="sn-card__head">
    <span class="sn-card__title">{{ title }}</span>
    <span class="sn-card__hint">{{ hint }}</span>
  </div>
  <ng-template #plainHead><label class="sn-step__label">{{ title }}</label></ng-template>
</ng-template>
